import React, { useState, useEffect } from 'react';
import { openAccessService } from '../services/api';

function OpenAccess() {
  const [openAccess, setOpenAccess] = useState({
    content: '',
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOpenAccess = async () => {
      try {
        const response = await openAccessService.get();
        if (response.data) {
          setOpenAccess({
            content: response.data.content || '',
          });
        }
      } catch (error) {
        console.error('Error fetching open access:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchOpenAccess();
  }, []);

  if (loading) {
    return (
      <div className="bg-gray-50 min-h-screen">
        <div className="flex items-center justify-center h-64">
          <div className="text-gray-500">در حال بارگذاری...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-gray-50 min-h-screen">
      <div className="bg-gradient-to-br from-blue-900 to-blue-800 text-white py-16">
        <div className="max-w-7xl mx-auto px-4">
          <h1 className="text-5xl font-bold mb-4">دسترسی آزاد</h1>
          <p className="text-xl text-blue-100">تمام مقالات به صورت آزاد و رایگان در دسترس</p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-16">
        {openAccess.content ? (
          <div className="bg-white rounded-xl shadow-md p-8">
            <div className="text-gray-700 leading-relaxed whitespace-pre-wrap">
              {openAccess.content}
            </div>
          </div>
        ) : (
          <div className="bg-white rounded-xl shadow-md p-8 text-center text-gray-500">
            <p>اطلاعاتی برای نمایش وجود ندارد</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default OpenAccess;
